export enum Permission {
  PartnerPickDevicesManageShoppers = 'manage_shoppers.legacy_permission',
}
